// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6fa34748","885":"4f326a7f"}[chunkId] + ".chunk.js";
};